export class InvalidPackageError extends Error {
	constructor(public invalidPackageMessage: string) {
		super(invalidPackageMessage);
	}
}

export function isInvalidPackageError(error: InvalidPackageError): error is InvalidPackageError {
	return error.invalidPackageMessage !== undefined;
}
